// extracted by mini-css-extract-plugin
module.exports = {"red":"chapters_red__1MFUI","green":"chapters_green__1FYKT","blue":"chapters_blue__3d8Th","primary":"chapters_primary__3Z0VL","orange":"chapters_orange__QA6UC"};